import React, { useState } from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import { apirequest } from "../../API/api";
import { endpoint } from "../../API/config";
import DocumentPlusIcon from "../../assets/icons/document.svg";
import BreadCrumb from "../../components/global/breadcrumbs/BreadCrumb";
import Loading from "../../components/global/loader/Loading";
import Header from "../../components/header/Header";
import SlideshowTable from "../../components/home/slideshow/SlideshowTable";
import BackendTableSearch from "../../components/table/BackendTableSearch";
import TablePagination from "../../components/table/TablePagination";
import useDebounce from "../../hooks/useDebounce";

const ProductGroupListing = () => {
  const column = [
    { col: "1", width: "5%" },
    { col: "2", width: "91.5%" },
    { col: "3", width: "" },
    { col: "4", width: "20%" },
  ];

  const [getproductGroupData, setGetProductGroupdata] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const debouncedSearch = useDebounce(searchValue, 500);

  // API's for product group Listing
  const { isSuccess, error, status } = useQuery(
    [`${endpoint.get_productGroup.key}`, debouncedSearch],
    () =>
      apirequest({
        url: `${endpoint.get_productGroup.addr}`,
        params: {
          searchKeyword: debouncedSearch,
        },
      }),
    {
      onSuccess: (res) => setGetProductGroupdata(res),
      onError: () => setGetProductGroupdata([]),
    }
  );

  /* Limit Data To Show to 10 */
  const dataPerPage = 10;
  const indexOfLastItem = currentPage * dataPerPage;
  const indexOfFirstItem = indexOfLastItem - dataPerPage;
  const paginate = (pageNumbers) => {
    setCurrentPage(pageNumbers);
  };

  return (
    <div id="courses">
      <Header />
      {!isSuccess && error?.status !== 404 && <span>{error?.message}</span>}
      <div className="courses">
        <div className="courseTable mt-9">
          <div className="courseTable__head flex justify-between  md:mt-[2%] md-mb-[5%] md:mx-9 pl-[2%]">
            <div className="flex">
              <BreadCrumb />
            </div>

            <div className="ml-4 flex">
              {/* <TableSearch
                  defaultData={productGroups_DefaultData}
                  setDefaultData={setGetProductGroupdata}
                  dataKey="productGroupName"
                  dataForFilter={productGroups_DefaultData?.data.data}
                  name="Courseware"
                  subModuleName="Master"
                  setCurrentPage={setCurrentPage}
                  childName="Product Groups"
                  childModuleName=""
                  placeholder="Search by Product Group"
                /> */}

              <BackendTableSearch
                // dataKey="productGroupName"
                // dataForFilter={productGroups_DefaultData?.data.data}
                placeholder="Search by Product Group"
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                setCurrentPage={setCurrentPage}
              />
              <Link to="/courseware/master/product-group">
                <button className="ml-6 bg-primary-200 text-white font-medium px-6 rounded-xl hover:opacity-75 shadow-outer font-ibm w-40 h-[56px]">
                  Add New Product Group
                </button>
              </Link>
            </div>
          </div>
          {status === "loading" && <Loading />}
          {isSuccess && (
            <>
              <div className="courseTable__body md:ml-[4%] md:mr-[34px] mt-4 shadow-outer pl-[2%] pr-[5%] rounded-xl bg-white pb-[2%]">
                <SlideshowTable
                  icon={DocumentPlusIcon}
                  column={column}
                  currentData={getproductGroupData?.data?.data?.slice(
                    indexOfFirstItem,
                    indexOfLastItem
                  )}
                  type={"course"}
                />
              </div>
              <div className="courseTable__footer mx-auto mb-7">
                <TablePagination
                  data={getproductGroupData?.data?.data}
                  dataPerPage={dataPerPage}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  paginate={paginate}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductGroupListing;
